"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Order_1 = require("../../../../../classes/Order");
var Product_1 = require("../../../../../classes/Product");
var Coupon_1 = require("../../../../../classes/Coupon");
var Cashier_1 = require("../../../../../classes/Cashier");
var BillingGateway_1 = require("../../../../../classes/billing/BillingGateway");
var PaymentRequest_1 = require("../../../../../common/payments/PaymentRequest");
var AdminStudentCreateOrderController = /** @class */ (function () {
    function AdminStudentCreateOrderController($state, $stateParams, UsersModel, FlashService, OrdersModel, ProductsModel, CouponsModel, CreateOrderService, Stripe3DSService, $scope, CustomerSourceModel) {
        var _this = this;
        /** The order form only builds the order; this screen sends it and sees the answer, so it holds the key. */
        this.newOrder = new PaymentRequest_1.PaymentRequest();
        this.customerSource = null;
        this.marketingOptions = [];
        CustomerSourceModel.getCustomerSources().then(function (response) {
            _this.marketingOptions = response.customer_sources;
        });
        this.Stripe3DSService = Stripe3DSService;
        this.$scope = $scope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.UsersModel = UsersModel;
        this.OrdersModel = OrdersModel;
        this.CouponsModel = CouponsModel;
        this.FlashService = FlashService;
        this.CreateOrderService = CreateOrderService;
        this.product = null;
        this.products = [];
        this.$cashier = CreateOrderService.cashier();
        this.$order = this.$cashier.order();
        this.student = this.$cashier.order().student();
        this.$cashier.$addresses = [];
        this.$cashier.$paymentMethods = [];
        CreateOrderService.updateBillingAddressesList();
        CreateOrderService.updatePaymentMethodsList();
        this.couponConfig = {
            loading: true,
            coupon: {
                start: undefined,
            },
            showNewCouponForm: false,
            datepicker: {
                open: function ($event) {
                    _this.couponConfig.datepicker.status.opened = true;
                },
                dateOptions: {
                    formatYear: "yy",
                    startingDay: 7,
                    showWeeks: false,
                    minDate: new Date(),
                },
                format: "dd-MMMM-yyyy",
                status: {
                    opened: false,
                },
            },
            datepicker2: {
                open: function ($event) {
                    _this.couponConfig.datepicker2.status.opened = true;
                },
                dateOptions: {
                    formatYear: "yy",
                    startingDay: 7,
                    showWeeks: false,
                    minDate: function () { return _this.couponConfig.coupon.start; },
                },
                format: "dd-MMMM-yyyy",
                status: {
                    opened: false,
                },
            },
        };
        this.CouponsModel.get({ paging: false, valid: true }).then(function (response) {
            var coupons = response.coupons.map(function (data) { return new Coupon_1.Coupon(data); });
            _this.coupons = coupons;
            _this.couponConfig.loading = false;
        });
        ProductsModel.get({ paging: false, disabled: 0 }).then(function (response) {
            _this.products = response.products.data.map(function (product) { return new Product_1.Product(product); });
            _this.loading = false;
            _this.submitting = false;
        });
        this.createOrder = this.createOrder.bind(this);
        this.handlePaypalOrderComplete = this.handlePaypalOrderComplete.bind(this);
    }
    AdminStudentCreateOrderController.prototype.addCustomerSourceToOrder = function () {
        this.$cashier.addCustomerSource(this.customerSource);
        this.customerSource = null;
    };
    AdminStudentCreateOrderController.prototype.applyCoupon = function () {
        this.$cashier.addCoupon(this.selectedCoupon);
        this.$cashier.calculateTotal();
        if (this.$cashier.order().payments().length > 0) {
            this.$cashier.order().payments()[0].setAmount(this.$cashier.totalDue());
        }
        delete this.selectedCoupon;
    };
    AdminStudentCreateOrderController.prototype.removeCoupon = function () {
        this.$cashier.removeCoupon();
        this.$cashier.calculateTotal();
        if (this.$cashier.order().payments().length > 0) {
            this.$cashier.order().payments[0].setAmount(this.$cashier.totalDue());
        }
    };
    AdminStudentCreateOrderController.prototype.createOrder = function (order) {
        return __awaiter(this, void 0, void 0, function () {
            var data, response, threeDSResult, confirmResponse, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Disables the order form's buttons while the order is sent, as on the
                        // CRM page; a double click made two orders.
                        this.submitting = true;
                        order.submitted = true;
                        data = (0, Cashier_1.cashierOrderRequestTransformer)(this.$cashier);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        return [4 /*yield*/, this.OrdersModel.create(this.newOrder.bodyFor((0, PaymentRequest_1.orderWithoutOneTimeTokens)(data), function (requestId) { return (__assign(__assign({}, data), { request_id: requestId })); }))];
                    case 2:
                        response = _a.sent();
                        this.newOrder.settled(PaymentRequest_1.PaymentOutcome.answered(response));
                        if (!this.Stripe3DSService.isThreeDSecureRequired(response)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.Stripe3DSService.handle3DSChallenge(response.client_secret, this.stripePublishableKey())];
                    case 3:
                        threeDSResult = _a.sent();
                        if (!threeDSResult.success) {
                            this.newOrder.settled(PaymentRequest_1.PaymentOutcome.challengeFailed(threeDSResult));
                            this.FlashService.setMessage({
                                type: "error",
                                message: threeDSResult.error ||
                                    "Payment authentication failed. Please try again.",
                            });
                            order.submitted = false;
                            this.submitting = false;
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.Stripe3DSService.confirmOrderPayment(response.order_id, response.payment_intent_id, {
                                student_id: this.$cashier.order().student().id(),
                                amount: response.amount,
                            })];
                    case 4:
                        confirmResponse = _a.sent();
                        this.newOrder.settled(PaymentRequest_1.PaymentOutcome.answered(confirmResponse));
                        this.FlashService.setMessage({
                            type: "success",
                            message: confirmResponse.message,
                        });
                        this.reset();
                        this.$state.go("drivecoach.admin.students.view", { userId: this.$stateParams.userId }, { reload: true });
                        return [2 /*return*/, confirmResponse];
                    case 5:
                        this.FlashService.setMessage({
                            type: "success",
                            message: response.message,
                        });
                        this.reset();
                        if (response.student_activated === true) {
                            this.$state.go("drivecoach.admin.students.view", { userId: this.$stateParams.userId }, { reload: true });
                        }
                        else {
                            this.$state.go("drivecoach.admin.students.verification");
                        }
                        return [2 /*return*/, response];
                    case 6:
                        error_1 = _a.sent();
                        this.newOrder.settled(PaymentRequest_1.PaymentOutcome.failed(error_1));
                        order.submitted = false;
                        this.submitting = false;
                        return [3 /*break*/, 8];
                    case 7:
                        // Awaited native promises run outside AngularJS's digest.
                        this.$scope.$applyAsync();
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    /** Only a Stripe school's card answers 202 requires_action. */
    AdminStudentCreateOrderController.prototype.stripePublishableKey = function () {
        return (0, BillingGateway_1.createBillingGatewayFromPolicies)(this.$cashier.policies()).config()
            .stripe_publishable_key;
    };
    AdminStudentCreateOrderController.prototype.reset = function () {
        this.$order = new Order_1.Order();
        this.product = null;
        delete this.selectedCoupon;
        this.loading = false;
        this.submitting = false;
    };
    AdminStudentCreateOrderController.prototype.addProductToOrder = function () {
        this.$cashier.addProduct(this.product);
        var totalWithoutSurcharge = this.$cashier.totalDue();
        //set initial value for "amount paid today" field
        this.$cashier.order().payments()[0].setAmount(totalWithoutSurcharge);
        this.$cashier.calculateTotal();
    };
    AdminStudentCreateOrderController.prototype.createCoupon = function () {
        var _this = this;
        this.couponConfig.loading = true;
        var coupon = Object.assign({}, this.couponConfig.coupon);
        if (coupon.type === "fixed") {
            coupon.amount = coupon.amount * 100;
        }
        this.CouponsModel.create(coupon).then(function (response) {
            _this.couponConfig.loading = false;
            var newCoupon = new Coupon_1.Coupon(response.coupon);
            _this.coupons.push(newCoupon);
            _this.FlashService.setMessage({
                message: response.message,
                type: "success",
            });
            _this.couponConfig.coupon = {};
            _this.selectedCoupon = newCoupon;
            _this.applyCoupon();
        });
    };
    /**
     * Handle PayPal order completion.
     * For PayPal, the order is already created and payment is already captured
     * by the PayPal component. We just need to show success and navigate.
     */
    AdminStudentCreateOrderController.prototype.handlePaypalOrderComplete = function (orderId, studentId) {
        this.FlashService.setMessage({
            type: "success",
            message: "Order completed successfully.",
        });
        this.reset();
        this.$state.go("drivecoach.admin.students.view", { userId: studentId }, { reload: true });
    };
    return AdminStudentCreateOrderController;
}());
AdminStudentCreateOrderController.$inject = [
    "$state",
    "$stateParams",
    "UsersModel",
    "FlashService",
    "OrdersModel",
    "ProductsModel",
    "CouponsModel",
    "CreateOrderService",
    "Stripe3DSService",
    "$scope",
    "CustomerSourceModel",
];
exports.default = AdminStudentCreateOrderController;
